import React from "react";
import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/react";
import UploadProformaInvoicePageModal from "@/features/invoices/proforma-invoices/upload-proforma-invoice-page-modal";
import { LightOrderSheetSet } from "@/features/order-sheets/order-sheet.type";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  buyerId: number;
  boutiqueId: number;
  orderSheetSet: LightOrderSheetSet;
  // 라인시트세트 통화 — 원화면 프로포마도 원화로 올린다
  currency?: string | null;
  // 라인시트세트 시즌 — 연결할 OC를 이 시즌으로 찾는다
  season?: string;
}

export default function AddProformaInvoiceModalSeason({ isOpen, onClose, buyerId, boutiqueId, orderSheetSet, currency, season }: Props) {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent borderRadius={"8px"} overflow={"hidden"} maxWidth={"1600px"}>
        <ModalBody display="flex" flexDirection={"column"} gap={"12px"} >
          {/* 스탁과 같은 모달 — 시즌은 OC 연결·디파짓이 더해진다 */}
          <UploadProformaInvoicePageModal
            isSeason={true}
            season={season}
            buyerId={buyerId}
            boutiqueId={boutiqueId}
            orderSheetSet={orderSheetSet}
            currency={currency}
            handleClose={handleClose}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
